import React, { Component } from 'react';
import AddItem from './add-item/add-item';
import EditItem from './edit-item/edit-item';
import Edit from '../../../assets/images/edit.svg';
import Delete from '../../../assets/images/delete.svg';
import Button from '../../../home/button-classic/button-classic';
import Search from '../../../common/components/search-text/search-text';
import { companyName, chainType } from '../../../utils/constants';
import { getCookie } from "../../../utils/cookies";
import RateChart from './RateChart';
import Select from "react-select";
import { isSuperAdmin } from 'Utils/common';
import actions from 'src/common/action_constant';
import { connect } from "react-redux";
import { withRouter } from "react-router";
class PfizerItem extends Component {
    constructor() {
        super();
        this.state = {
			isOpen : false,
			isEdit : false,
			count : 50,
			offset : 0,
			editedData : '',
			search: '',
			selectedSeekerCompany:'',
			seekerCompanyOptions: [],
		}
	}
	

	componentDidMount = () => {
		window.addEventListener('scroll', this.handleScroll);
		if(isSuperAdmin()) {
			this.fetchAllSeekers();
		}
		this.getInventoryItem();
		// this.props.downloadInventoryItem();
		this.props.getPackagingDetails()
	}

	fetchAllSeekers = () => {
    const { dispatch } = this.props;
		const onSuccess = (data) => {
			const options = data.map((item) => ({
				value: item.id,
				label: item.company_name,
			}));
			this.setState({ seekerCompanyOptions : options });
		}
    dispatch({ type: actions.HOME.FETCH_ALL_SEEKERS , onSuccess});
  }

	getInventoryItem = () => {
		const { dispatch } = this.props;
		const { selectedSeekerCompany } = this.state;
		const company_id = selectedSeekerCompany ? selectedSeekerCompany.value : JSON.parse(getCookie('user')).company_id;
		let param = `${company_id}&count=${this.state.count}&offset=${this.state.offset}`;
		if(this.state.search) {
			param += `&search=${this.state.search}`;
		}
		dispatch({ type : actions.MASTER.INVENTORY_ITEM.GET_INVENTORY_ITEM, param, company_id });
	}

    toggleAdd = (isType, data='') => {
		if(isType == "Edit") {
			this.setState({isEdit : !this.state.isEdit, editedData : data});
		} else {
			this.setState({isOpen : !this.state.isOpen});
		}
	}

	getCompanyName = (id) => {
		let company = companyName.find((val) => {
			return val.value == id;
		});
		return company && company.label ? company.label : '';
	}

	getChain = (type) => {
		let chain = chainType.find((val) => {
			return val.value == type;
		});
		return chain && chain.label ? chain.label : '';
	}

	onDownload = () => {
			const company_id = JSON.parse(getCookie('user')).company_id;
		const { dispatch } = this.props;
		dispatch({ 
			type : actions.MASTER.INVENTORY_ITEM.DOWNLOAD_INVENTORY_ITEM,
			company_id,
			onSuccess: ((data) => {
         this.setState({
            downloadUrl1: data.url
            });
         this.downloadUrl.click();
         })

		})
		
	}

	onDownloadTemplate = () => {
const company_id = JSON.parse(getCookie('user')).company_id;
		const { dispatch } = this.props;
		dispatch({ 
			type : actions.MASTER.INVENTORY_ITEM.DOWNLOAD_INVENTORY_ITEM,
			company_id,
			onSuccess: ((data) => {
         this.setState({
            downloadTemplateUrl: data.url
            });
         this.downloadTemplateUrl.click();
         })
				})
	}

	onUpload = () => {
		this.uploadUrl.click();
	}

	uploadInventoryItem = (e) => {
		let formData = new FormData();
        formData.append('file', e.target.files[0]);
		this.props.uploadInventoryItem(formData);
	}

	uploadRateChart = (e) => {
		let formData = new FormData();
		const user = getCookie('user') && JSON.parse(getCookie('user')) || {};
        formData.append('file', e.target.files[0]);
		formData.append('user_id',user.user_id);
		formData.append('user_name',user.admin_name);
		this.props.uploadRateChart(formData);
	}
	
	componentWillUnmount() {
	window.removeEventListener('scroll', this.handleScroll)
	}

	changeHandler = (val,id) =>{
		this.setState({
			[id]: val
		});
	}

	submitSearch = () => {
		this.getInventoryItem();
	}

	clearFilterOnCancel = (e, type) => {
		this.setState({ search: '' }, () => {
			this.getInventoryItem();
		});
	}

	handleScroll = () => {
		// var wrappedElement =  document.getElementById('root');
		// if (wrappedElement.getBoundingClientRect().bottom < window.innerHeight) {
		// 	console.log(this.state.count);
		// 	this.setState({
		// 		count : this.state.count+50
		// 	},()=>{
		// 		const data = {
		// 			count : this.state.count,
		// 			offset : this.state.offset
		// 		}
		// 		this.props.getInventoryItem(data);
		// 	});
		// }
	}

	previous = () =>{
		if(this.state.offset > 0){
			this.setState({
				offset : this.state.offset-50
			},()=>{
				const data = {
					count : this.state.count,
					offset : this.state.offset
				}
				this.props.getInventoryItem(data);
			});
		}
	}

	next = () =>{
		this.setState({
			offset : this.state.offset+50
		},()=>{
			const data = {
				count : this.state.count,
				offset : this.state.offset
			}
			this.props.getInventoryItem(data);
		});
	}

	onClickRateChart = (val) => {
		this.props.getRateChartDetails(val, this.openRateChart);
	}

	openRateChart = (data, val) => {
		this.setState({
			rateChartData: data || [],
			materialName: val.materialName,
			materialDetails: val
		});
	}

	onAddRateChart = (data) => {
		this.props.onAddRateChart(data, this.state.materialDetails, this.openRateChart);
	}

	onDeleteRate = (data) => {
		this.props.onDeleteRate(data, this.state.materialDetails, this.openRateChart);
	}

	onUpdateRateChart = (data) => {
		this.props.onUpdateRateChart(data, this.state.materialDetails, this.openRateChart);
	}

	onCancel = () => {
		this.setState({
			rateChartData: [],
			materialName: '',
			materialDetails: ''
		});
	}
	onChangeSeekerCompany = (selectedOption) => {
		this.setState({ selectedSeekerCompany: selectedOption }, () => {
			this.getInventoryItem();
		})
	}

	handleOnClickProductAudit = () => {
    const {history} = this.props;
	const { selectedSeekerCompany } = this.state;
	const company_id = selectedSeekerCompany ? selectedSeekerCompany.value : JSON.parse(getCookie('user')).company_id;
    const masterType = 43
    const navUrl = `/auditScreen/${company_id}/${masterType}`;
    history.push(navUrl)
    }

    render() {
        return(<div className={'Pfizer-Item'}>
            <div className = "header">
						<div style={{ display: "flex", alignItems: "center", gap: "10px"}}>

							<Search id={'search'} value={this.state.search} placeholder={'Search'} changeHandler={this.changeHandler} click={this.submitSearch} canClear={this.state.search !== ''} handleClearFilter={(e) => this.clearFilterOnCancel(e, "seaech")} />
							{isSuperAdmin() && <div style={{ width: "300px", marginTop:"-20px" }}>
								<div style={{ fontSize: "10px", color: "#868e96" }}>
									Seeker Company
								</div>
								<Select
									options={this.state.seekerCompanyOptions}
									value={this.state.selectedSeekerCompany}
									onChange={this.onChangeSeekerCompany}
									placeholder="Select Seeker Company"
								/>
							</div>}
						</div>
        <Button value={' + Item'} click={this.toggleAdd}/>
				{/* <Button value={'Generate'} /> */}
				<Button value={'Upload'} click={this.onUpload}/>
				<input type='file' style={{ display: 'none'}}  ref={(e) => { this.uploadUrl = e ;}} onChange={this.uploadInventoryItem} onClick={(e) => {e.target.value = null }}/>
				<Button value={'Download'} click={this.onDownload}/>
				<a href={this.state.downloadUrl1} ref={(e) => { this.downloadUrl = e ;}} download style={{display: 'none'}}/>
				<Button value={'Upload Rate Chart'} click={() => { this.uploadRateChartUrl.click() }}/>
				<input type='file' style={{ display: 'none'}}  ref={(e) => { this.uploadRateChartUrl = e ;}} onChange={this.uploadRateChart} onClick={(e) => {e.target.value = null }}/>
				<Button value={'Download Rate Chart'} click={this.props.downloadRateChart}/>
				<Button value={'Download Template'} click={this.onDownloadTemplate}/>
				<a href={this.state.downloadTemplateUrl} ref={(e) => { this.downloadTemplateUrl = e ;}} download style={{display: 'none'}}/>
				<button
                className="button-classic mt-10"
                onClick={this.handleOnClickProductAudit}
                >
                Audit
              </button>
			</div>
			<div className = "item-table">
				<div className = "list-section item-header column">
					<div className = "item-label">Company</div>
					<div className = "item-label">Chain</div>
					<div className = "item-label product-label">Product Group</div>
					<div className = "item-label product-label">Product</div>
					<div className = "item-label">Physical State</div>
					<div className = "item-label">Inside Count</div>
					<div className = "item-label">Unit</div>
					<div className = "item-label">Volume</div>
					<div className = "item-label">Actual Weight</div>
					<div className = "item-label">Charged Weight</div>
					<div className = "item-label">Actions</div>
				</div>
				{this.props.itemData && this.props.itemData.map((val,index) => {
					return(<div className = "list-section item-header" key={index}>
					<div className = "item-label">{val.companyType}</div>
					<div className = "item-label">{val.chainType}</div>
					<div className = "item-label product-label">{val.mpgCode}</div>
					<div className = "item-label product-label">{`${val.product} - ${val.materialName}`}</div>
					<div className = "item-label">{val.physicalState}</div>
					<div className = "item-label">{val.insideCount}</div>
					<div className = "item-label">{val.unit}</div>
					<div className = "item-label">{val.volume}</div>
					<div className = "item-label">{val.actualWeight}</div>
					<div className = "item-label volumetric">{val.chargedWeight}</div>
					<div className = "item-label">
						<div className={'delete-icon'} style={{backgroundImage:`url(${Edit})`}} onClick={() => this.toggleAdd("Edit", val )}></div>
						<div className={'delete-icon'} style={{backgroundImage:`url(${Delete})`}} onClick={() => this.props.deleteInventoryItem(val.productMasterId)}></div>
						<br/><a onClick={() => this.onClickRateChart(val)} className={"theme-color fs-14 mt-5 curP"} style={{'marginTop': '5px'}}>Rate Chart</a>
					</div>
				</div>)})}
			</div>
			<div className="submit-section-pagination">
				<div className="next">
					<Button value="Next" click={this.next} />
				</div>
				{this.state.offset != 0 && <div className="pre">
					<Button value="Previous" click={this.previous} />
				</div>}
        	</div>
			{this.state.isOpen && 
				<AddItem 
					toggleAdd={this.toggleAdd} 
					addInventoryItem={this.props.addInventoryItem} 
					packagingDetails={this.props.packagingDetails}
					seekerCompanyOptions={this.state.seekerCompanyOptions}
				/>}
			{this.state.isEdit && 
				<EditItem 
					toggleAdd={this.toggleAdd} 
					data={this.state.editedData} 
					updateInventoryItem={this.props.updateInventoryItem} 
					packagingDetails={this.props.packagingDetails}
					seekerCompanyOptions={this.state.seekerCompanyOptions}
				/>}
			{this.state.materialName && 
			<RateChart 
				materialName={this.state.materialName} 
				onAddRateChart={this.onAddRateChart} 
				onCancel={this.onCancel} 
				rateChartData={this.state.rateChartData} 
				onDeleteRate={this.onDeleteRate} 
				onUpdateRateChart={this.onUpdateRateChart}/>}
        </div>
        )
    }
}

// export default PfizerItem;
export default connect()(withRouter(PfizerItem));
